'use strict';

var _ = require('lodash');
var StepEntitiesAndControlTypeController = function StepEntitiesAndControlTypeController($scope, cellRendererService, entityService, ScheduleChangeConstants, hepService, FeatureToggleService) {
  $scope.stepTitle = {
    'markets': 'Entities and Control Type',
    'legs': 'Leg Entity'
  };
  var MARKET_TYPE = ScheduleChangeConstants.TYPE.MARKETS;
  var FLIGHT_TYPE = ScheduleChangeConstants.TYPE.FLIGHTS;
  $scope.entityNameMsg = 'Entity name must be alphanumeric.';
  function flightEntityHep() {
    hepService.getHepByType('FlightEntity').then(function (flightHep) {
      _.forEach($scope.scheduleChange.managedEntities, function (entity) {
        _.forEach(flightHep.hepList, function (hep) {
          if (hep.attributes.origin === entity.origin && hep.attributes.destination === entity.destination) {
            entity.assignedEntity = hep.properties.entityName;
            return false;
          }
        });
      });
    });
  }
  if ($scope.wizardShown === ScheduleChangeConstants.ENTITIES.MARKETS) {
    $scope.entityOptions = entityService.getMarketEntities();
  } else {
    $scope.entityOptions = entityService.getFlightEntities();
    flightEntityHep();
  }
  $scope.controlTypeOptions = [{
    label: 'Physical',
    value: 'physical'
  }, {
    label: 'Financial',
    value: 'financial'
  }];
  $scope.createdEntity = null;
  $scope.customizableActions = [{
    label: 'Create New...',
    action: function action(combobox) {
      $scope.currentEntityCombobox = combobox;
      $scope.showCreateEntityDialog();
    }
  }, {
    label: 'Default',
    action: function action(combobox) {
      return combobox.selectItem('Default');
    }
  }];
  $scope.isSummaryVisible = false;
  $scope.stepEntered = function (event, stepTitle) {
    if (stepTitle === $scope.stepTitle[$scope.wizardShown]) {
      $scope.gridOptions.rowData = $scope.scheduleChange.significantManagedEntities;
      $scope.gridOptions.api.onNewRows();
      $scope.calculateGridHeight();
      $scope.gridOptions.api.sizeColumnsToFit();
    }
  };
  $scope.saveNewEntity = function () {
    $scope.xtForm.submit();
    if ($scope.xtForm.form.$valid) {
      $scope.entityOptions.push($scope.createdEntity);
      $scope.entityOptions.sort();
      $scope.currentEntityCombobox.addItem($scope.createdEntity);
      var type = $scope.wizardShown === ScheduleChangeConstants.ENTITIES.MARKETS ? MARKET_TYPE : FLIGHT_TYPE;
      entityService.saveMarketEntity($scope.createdEntity, type);
      $scope.createdEntity = null;
      $scope.xtForm.reset();
      $scope.hideCreateEntryDialog();
    } else if (_.get($scope, 'xtForm.form.$error.duplicated.length')) {
      $scope.isSummaryVisible = true;
    }
  };
  $scope.cancelCreateEntity = function () {
    $scope.xtForm.reset();
    $scope.isSummaryVisible = false;
    $scope.createdEntity = null;
    $scope.hideCreateEntryDialog();
  };
  $scope.hideSummary = function () {
    $scope.isSummaryVisible = false;
  };
  var controlTypeCellRenderer = function controlTypeCellRenderer(params) {
    return '<rm-segmented-radio-button input-name="market-control-type" items="controlTypeOptions" ' + 'ng-model="scheduleChange.significantManagedEntities[' + params.rowIndex + '].controlType">' + '</rm-segmented-button>';
  };
  var entityCellRenderer = function entityCellRenderer(params) {
    return '<rm-combobox item-list="entityOptions" type-ahead="true" customizable-items="customizableActions"' + 'fixed-position="true" ng-model="scheduleChange.significantManagedEntities[' + params.rowIndex + '].assignedEntity"></rm-combobox>';
  };
  var columnDefs = {};
  function filterByFeature(entry) {
    if (entry.showIfFeature && FeatureToggleService.isDisabled(entry.showIfFeature) || entry.hideIfFeature && FeatureToggleService.isEnabled(entry.hideIfFeature)) {
      return false;
    }
    return true;
  }
  var marketsColumnDefs = [{
    headerName: 'Market Name',
    field: 'market',
    cellRenderer: cellRendererService.marketCellRenderer,
    width: FeatureToggleService.isEnabled('MARKET_CONTROL_TYPE') ? 130 : 210
  }, {
    headerName: 'Control Type',
    field: 'controlType',
    cellRenderer: controlTypeCellRenderer,
    width: 180,
    cellClass: 'ag-cell-center',
    showIfFeature: 'MARKET_CONTROL_TYPE'
  }, {
    headerName: 'Assigned Entity',
    field: 'assignedEntity',
    cellRenderer: entityCellRenderer,
    width: FeatureToggleService.isEnabled('MARKET_CONTROL_TYPE') ? 260 : 320
  }];
  var legsColumnDefs = [{
    headerName: 'Leg',
    field: 'leg',
    cellRenderer: cellRendererService.marketCellRenderer,
    width: 120
  }, {
    headerName: 'Assigned Entity',
    field: 'assignedEntity',
    cellRenderer: entityCellRenderer
  }];
  marketsColumnDefs = _.filter(marketsColumnDefs, filterByFeature);
  columnDefs[ScheduleChangeConstants.ENTITIES.MARKETS] = marketsColumnDefs;
  columnDefs[ScheduleChangeConstants.ENTITIES.LEGS] = legsColumnDefs;
  $scope.gridOptions = _.defaults({
    columnDefs: columnDefs[$scope.wizardShown],
    rowData: $scope.scheduleChange.managedEntities
  }, $scope.defaultGridOptions);
  $scope.calculateGridHeight = function () {
    // Adding 1px to height to get rid of the vertical scrollbar
    $scope.height = $scope.defaultGridOptions.calculateGridHeight($scope.gridOptions.rowData.length, 10) + 1;
  };
};
StepEntitiesAndControlTypeController.$inject = ['$scope', 'CellRendererService', 'StepControlTypeEntityService', 'ScheduleChangeConstants', 'HepService', 'FeatureToggleService'];
module.exports = StepEntitiesAndControlTypeController;